var map = {
	"./bg.jpeg": 1234,
	"./bg.png": 1469,
	"./bg1.png": 5872,
	"./bg10.png": 4898,
	"./bg2.png": 1275,
	"./bg3.png": 7618,
	"./bg4.png": 413,
	"./bg5.png": 9284,
	"./bg6.png": 1743,
	"./bg7.png": 2998,
	"./bg8.png": 2801,
	"./bg9.png": 88,
	"./logo.png": 3153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;